import Vue from "vue";
import Router from "vue-router";
import ViewLogin from "../views/ViewLogin.vue";
import ViewMain from "../views/ViewMain.vue";
import course from "../views/Course";
import courseList from "../views/CourseList";
import game from "../views/Game";
import home from "../views/Home";
import material from "../views/Material";
import theme from "../views/Theme";
import setting from "../views/Setting";
import Share from "../views/Course/sharePassword.vue";
import FormComon from '../views/FormComon/index.vue';
import FormComonSelf from '../views/FormComon/self.vue';

Vue.use(Router);

export default new Router({
  mode: "history",

  routes: [
    {
      path: "/",
      name: "ViewMain",
      component: ViewMain,
      meta: {
        label: "imkid课件管理",
      },
      children: [
        course,
        courseList,
        game,
        home,
        material,
        theme,
        setting,
      ],
    },
    {
      path: "/login",
      name: "ViewLogin",
      component: ViewLogin,
    },
    {
      path: "/share",
      name: "Share",
      component: Share,
    },
    {
      path: "/form",
      name: "FormComon",
      component: FormComon,
    },
    {
      path: "/self",
      name: "FormComonSelf",
      component: FormComonSelf,
    },
  ],
});
